
export default {
    methods: {
        trackTeaser: function (title) {
            // eslint-disable-next-line
            gtag('event', 'page_view', {
                page_location: process.env.BASE_URL,
                page_path: window.location.pathname,
                page_title: title
            });
        }
    }
}